import {Dispatch, SetStateAction} from 'react'
import {v4 as uuidv4} from 'uuid'
import {parseISO} from 'date-fns'
import {Input, Switch, Space} from 'antd'

import styles from './ConditionForm.module.scss'
import {
  Form,
  FormItem,
  Button,
  DatePicker,
  UserAvatar,
  Text,
} from 'common/components'
import {formatDate} from 'common/helpers'
import {FIELD_RULES} from 'common/constants'
import {useCreateProjectCondition} from '..'

interface ConditionFormProps {
  noBorrower?: boolean
  request?: any
  condition?: any
  setConditions?: Dispatch<SetStateAction<any[]>>
  onClose: () => void
}

const {TextArea} = Input

export default function ConditionForm({
  noBorrower,
  request,
  condition,
  setConditions,
  onClose,
}: ConditionFormProps) {
  const {mutate: createProjectCondition, isMutating} =
    useCreateProjectCondition(request.project.uuid, request.uuid, onClose)

  const isEdit = Boolean(condition)

  const handleFinish = ({date, ...values}: any) => {
    const newValues = {...values, date: formatDate(date, 'server')}
    if (!setConditions) return createProjectCondition(newValues)
    isEdit
      ? setConditions((state) =>
          state.map((item) =>
            item.uuid === condition.uuid
              ? {
                  ...item,
                  ...newValues,
                }
              : item
          )
        )
      : setConditions((state) => [...state, {...newValues, uuid: uuidv4()}])
    onClose()
  }

  const initialValues = condition
    ? {
        date: parseISO(condition.date),
        description: condition.description,
        borrowerVisibility: noBorrower ? false : condition.borrowerVisibility,
      }
    : {
        borrowerVisibility: false,
      }

  const borrower = request.project.borrower

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <FormItem name="date" label="Condition date" rules={FIELD_RULES}>
        <DatePicker maxDate={parseISO(request.maturityDate)} />
      </FormItem>
      <FormItem name="description" label="Description" rules={FIELD_RULES}>
        <TextArea rows={5} />
      </FormItem>
      {noBorrower ? (
        <FormItem hidden name="borrowerVisibility" />
      ) : (
        <div className={styles.switch}>
          <Space size={6}>
            <UserAvatar
              size={24}
              src={borrower?.photo}
              alt={borrower ? borrower.firstName : 'Borrower'}
            />
            <Text size="md" weight="demiBold" color="black">
              Show borrower
            </Text>
          </Space>
          <FormItem noStyle name="borrowerVisibility" valuePropName="checked">
            <Switch />
          </FormItem>
        </div>
      )}
      <Button block htmlType="submit" loading={isMutating}>
        Add condition
      </Button>
    </Form>
  )
}
